// extracted by mini-css-extract-plugin
export default {"loginSignupHeader":"login_loginSignupHeader__vtsjj","loginForm":"login_loginForm__vXzCF","field":"login_field__N+ydn"};